import React, { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import "./createtask.scss";
import Navbar from "../landing/header/Navbar";
import ReactQuill from "react-quill";
// import 'react-quill/dist/quill.snow.css';
import TextEditor from "./TextEditor";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { API_URL } from "../../utils/ApiUrl";
import CreateTast from "../../hooks/write/crateTask";
import Allowance from "../../hooks/read/approveAllowance";
import { toast } from "react-toastify";
import Loader from "../../hooks/loader";
import { Link, useNavigate } from "react-router-dom";
import BalanceOf from "../../hooks/read/balanceOf";
import useWeb3 from "../../hooks/useWeb3";
import { useWeb3React } from "@web3-react/core";
import CustomSelect from "../CustomSelect/CustomSelect";
import TimezoneDropdown from "./TimeZone";
import { useLocation } from "react-router-dom";
import ServiceType from "./ServiceType";
import Environment from "../../utils/Environment";

import axios from "axios";
import TitleInput from "./TaskTitleInput";
import { deliveryFormats } from "../../constants/deliveryFormats";
import { tokens } from "../../constants/tokens";
import getDollarValueOfToken from "../../services/tokenPrice_usd";
import { validateEndDate } from "../../utils/validateEndData";
import CustomToast from "../CustomToast";
import copy from "copy-to-clipboard";



const Createtask = () => {

  const navigate = useNavigate();;
  let { BalanceOfHook } = BalanceOf();

  const [value, setValue] = useState(localStorage.getItem("description") || ""); // Task description value
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);
  const [hasAllowance, setHasAllowance] = useState(false);

  const [taskCreated, setTaskCreated] = useState(null);
  console.log(taskCreated, "taskCreated....");

  const [taskRequirements, setTaskRequirements] = useState(
    localStorage.getItem("taskRequirements") || ""
  );
  const [additionalRequest, setAdditionalRequest] = useState(
    localStorage.getItem("additionalRequest") || ""
  );
  const [selectedOptions, setSelectedOptions] = useState(
    JSON.parse(localStorage.getItem("selectedOptions")) || []
  );
  const [loader, setLoader] = useState(false);
  const [deliveryFormat, setDeliveryFormat] = useState(
    JSON.parse(localStorage.getItem("deliveryFormat")) || []
  );
  const [selectedTimezone, setSelectedTimezone] = useState(
    localStorage.getItem("selectedTimezone") || "Select time zone"
  );
  const [serviceType, setServiceType] = useState(
    localStorage.getItem("serviceType") || "Digital"
  ); // Default to "Digital"
  const [selectedCountry, setSelectedCountry] = useState(
    localStorage.getItem("selectedCountry") || null
  );
  const [selectedCity, setSelectedCity] = useState(
    localStorage.getItem("selectedCity") || null
  );

  // console.log(selectedCity, selectedCountry, 'selectedOptions');
  const handleShow = () => setShow(true);
  const { createTast } = CreateTast();
  const { AllowanceCore, checkAllowanceOnly } = Allowance();
  const { account } = useWeb3React();
  const web3 = useWeb3();
  const location = useLocation();
  // Form states
  const [title, setTitle] = useState(localStorage.getItem("title") || "");
  const [reward, setReward] = useState(localStorage.getItem("reward") || "");
  const [contact, setContact] = useState(localStorage.getItem("contact") || "");
  const [endDate, setEndDate] = useState(localStorage.getItem("endDate") || "");
  const [selectedCategory, setSelectedCategory] = useState(
    JSON.parse(localStorage.getItem("selectedCategory")) || ""
  );
  const [selectedToken, setSelectedToken] = useState(
    JSON.parse(localStorage.getItem("selectedToken")) || {}
  );
  const queryParams = new URLSearchParams(location.search);
  // Get the 'edit' parameter from the URL
  const editId = queryParams.get('edit');
  // Error states
  const [errors, setErrors] = useState({});
  const [categories, setCategories] = useState([
    {
      categoryName: "Logistics & Supply Chain",
      id: 15,
    },
  ]);
  // console.log('errors', errors);

  useEffect(() => {
    localStorage.setItem("title", title);
    localStorage.setItem("reward", reward);
    localStorage.setItem("contact", contact);
    localStorage.setItem("endDate", endDate);
    localStorage.setItem("selectedCategory", JSON.stringify(selectedCategory));
    localStorage.setItem("selectedToken", JSON.stringify(selectedToken));
    localStorage.setItem("description", value);

    localStorage.setItem("deliveryFormat", JSON.stringify(deliveryFormat));
    localStorage.setItem("selectedTimezone", selectedTimezone);
    localStorage.setItem("additionalRequest", additionalRequest);
    localStorage.setItem("taskRequirements", taskRequirements);
    localStorage.setItem("selectedOptions", JSON.stringify(selectedOptions));
    localStorage.setItem("serviceType", serviceType);
    selectedCity && localStorage.setItem("selectedCity", selectedCity);
    selectedCountry && localStorage.setItem("selectedCountry", selectedCountry);
    // serviceType
    // selectedCity
    // selectedCountry
  }, [
    title,
    reward,
    contact,
    endDate,
    selectedCategory,
    selectedToken,
    value,
    selectedTimezone,
    deliveryFormat,
    additionalRequest,
    taskRequirements,
    selectedOptions,
    selectedCountry,
    selectedCity,
    serviceType,
  ]);
  useEffect(() => {
    const savedDescription = localStorage.getItem("description");
    if (savedDescription) {
      setValue(savedDescription);
    }
  }, []);
  // Validate form fields
  const validate = () => {
    const newErrors = {};
    if (!title) newErrors.title = "Task title is required";
    if (!value) newErrors.description = "Description is required";
    if (!reward) newErrors.reward = "Reward amount is required";
    if (!selectedCategory)
      newErrors.category = "Category selection is required";
    if (!selectedToken.currencySymbol)
      newErrors.currency = "Currency selection is required";
    if (!endDate) newErrors.endDate = "End date is required";
    if (selectedTimezone == "Select time zone")
      newErrors.selectedTimezone = "TimeZone is required";
    if (!deliveryFormat || deliveryFormat?.length < 1)
      newErrors.deliveryFormat = "Delivery format is required";
    //  if (!selectedCity) newErrors.deliveryFormat = "City is Required";
    //   if (!selectedCountry) newErrors.deliveryFormat = "Country is Required";
    return newErrors;
  };

  // Handle real-time input validation
  const handleInputChange = (field, value) => {
    switch (field) {
      case "title":
        setTitle(value);
        if (errors.title) {
          setErrors((prev) => ({ ...prev, title: "" })); // Clear error when user types
        }
        break;
      case "description":
        setValue(value);
        if (errors.description) {
          setErrors((prev) => ({ ...prev, description: "" }));
        }
        break;
      case "taskRequirements":
        setTaskRequirements(value);
        if (errors.taskRequirements)
          setErrors((prev) => ({ ...prev, taskRequirements: "" }));
        break;
      case "additionalRequest":
        setAdditionalRequest(value);
        if (errors.additionalRequest)
          setErrors((prev) => ({ ...prev, additionalRequest: "" }));
        break;
      case "reward":
        if (value === "" || /^\d*\.?\d*$/.test(value)) {
          setReward(value);
        }
        if (errors.reward) {
          setErrors((prev) => ({ ...prev, reward: "" }));
        }
        break;
      case "contact":
        setContact(value);
        if (errors.contact) {
          setErrors((prev) => ({ ...prev, contact: "" }));
        }
        break;
      case "endDate":
        setEndDate(value);
        if (errors.endDate) {
          setErrors((prev) => ({ ...prev, endDate: "" }));
        }
        break;
      case "deliveryFormat":
        setDeliveryFormat(value);
        if (errors.deliveryFormat) {
          setErrors((prev) => ({ ...prev, deliveryFormat: "" }));
        }
        break;
      case "selectedTimezone":
        setSelectedTimezone(value);
        if (errors.selectedTimezone) {
          setErrors((prev) => ({ ...prev, selectedTimezone: "" }));
        }
        break;
      default:
        break;
    }
  };

  // Handle real-time category selection and error removal
  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
    if (errors.category) {
      setErrors((prev) => ({ ...prev, category: "" })); // Clear category error when selected
    }
  };

  // Handle real-time token (currency) selection and error removal
  const handleTokenSelect = (token) => {
    setSelectedToken(token);
    if (errors.currency) {
      setErrors((prev) => ({ ...prev, currency: "" })); // Clear currency error when selected
    }
  };
  // Function to check if a value is non-empty
  function isNonEmpty(value) {
    if (value === null || value === undefined) return false; // Check for null or undefined
    if (typeof value === "string" && value.trim() === "") return false; // Check for empty strings
    if (Array.isArray(value) && value.length === 0) return false; // Check for empty arrays
    if (typeof value === "object" && Object.keys(value).length === 0)
      return false; // Check for empty objects
    return true; // Non-empty value
  }
  const handleEdit = async () => {
    const validation = validateEndDate(endDate);

    if (!validation.isValid) {
      return toast.error(validation.message);
    }
    if (!account) {
      return toast.error("Please connect to your wallet");
    }
    // Additional validation for Physical service type
    if (serviceType === "Physical") {
      if (!selectedCountry) {
        return toast.error("Please select a country for a physical service");
      }
      if (!selectedCity) {
        return toast.error("Please select a city for a physical service");
      }
    }

    // Validate form data
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      return setErrors(validationErrors); // Stop form submission if there are errors
    }


    setLoader(true);
    await editTaskData();
  };


  //   // Return valid status
  //   return { isValid: true, message: "" };
  // }
  async function disputeTypeFunc() {
    try {
      let taskData = {
        reward: reward,
        currencySymbol: selectedToken?.currencySymbol
      }
      let dollorValue = await getDollarValueOfToken(taskData)
      if (dollorValue >= 10) {
        return 1;
      } else {
        return 0;
      }
    } catch (error) {
      throw error
    }
  }
  console.log(selectedToken, 'selectedToken AllowanceCore');
  console.log(selectedToken.currencyAddress, "selectedToken.currencyAddress AllowanceCore");


  const handleApproval = async () => {
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      CustomToast.show('error', 'Error!', 'Please check your inputs, something is missing');
      return false;
    }

    const validation = validateEndDate(endDate);
    if (!validation.isValid) {
      CustomToast.show('error', 'Error!', validation.message);
      return false;
    }

    if (serviceType === "Physical") {
      if (!selectedCountry) {
        CustomToast.show('error', 'Error!', 'Please select a country for a physical service');
        return false;
      }
      if (!selectedCity) {
        CustomToast.show('error', 'Error!', 'Please select a city for a physical service');
        return false;
      }
    }

    if (!account) {
      CustomToast.show('error', 'Error!', 'Please connect to your wallet');
      return false;
    }

    setLoader(true);

    try {
      const platformFee = parseFloat(reward) * (selectedToken.currencySymbol === 'TASK' ? 0.03 : 0.05);
      const TOTAL_REQUIRED_REWARD_AMOUNT = parseFloat(reward) + platformFee;

      await AllowanceCore(
        Environment.tastManager,
        selectedToken.currencyAddress,
        TOTAL_REQUIRED_REWARD_AMOUNT,
        selectedToken.decimal,
        selectedToken.currency
      );

      setHasAllowance(true);
      CustomToast.show('success', 'Success!', 'Approval successful!');
      return true;
    } catch (error) {
      const errorMessage = error?.message || 'Approval failed';
      CustomToast.show('error', 'Error!', errorMessage);
      return false;
    } finally {
      setLoader(false);
    }
  };



  const handleCreateTask = async () => {
    const validation = validateEndDate(endDate);
    if (!validation.isValid) {
      return toast.error(validation.message);
    }

    if (!account) {
      return toast.error("Please connect to your wallet");
    }

    if (serviceType === "Physical") {
      if (!selectedCountry) {
        return toast.error("Please select a country for a physical service");
      }
      if (!selectedCity) {
        return toast.error("Please select a city for a physical service");
      }
    }

    const validationErrors = validate();
    // You can handle form validationErrors if needed

    let taskId;
    let taskTransactionHash;
    let disputeType; // ✅ Fix: Declare disputeType at the correct scope

    try {
      setLoader(true);

      let taskInfo = {
        percentage: '',
        percentageValue: ''
      };

      if (selectedToken.currencySymbol === 'TASK') {
        disputeType = 0;
        taskInfo = {
          percentage: 3,
          percentageValue: 0.03
        };
      } else {
        disputeType = await disputeTypeFunc(); // ✅ Now assigned properly
        taskInfo = {
          percentage: 5,
          percentageValue: 0.05
        };
      }

      const balance = await getBalance(selectedToken);
      const platformFee = parseFloat(reward) * taskInfo.percentageValue;
      const TOTAL_REQUIRED_REWARD_AMOUNT = parseFloat(reward) + platformFee;

      if (parseFloat(balance) < TOTAL_REQUIRED_REWARD_AMOUNT) {
        setLoader(false);
        return toast.error(
          `Balance must be greater than ${selectedToken.currencySymbol} reward + ${taskInfo.percentage}% fee: ${TOTAL_REQUIRED_REWARD_AMOUNT.toFixed(2)}`
        );
      }

      if (parseFloat(balance) < parseFloat(reward)) {
        setLoader(false);
        return toast.error(
          `Balance must be greater than ${selectedToken.currencySymbol} reward amount`
        );
      }

      const epochTime = Math.floor(new Date(endDate).getTime() / 1000);

      console.log(
        reward,
        title,
        value,
        // reward,
        selectedToken.currencyAddress,
        selectedToken.decimal,
        disputeType,
        ".....Creating task with above details"
      );

      const res = await createTast(
        reward,
        title,
        value,
        // reward,
        selectedToken.currencyAddress,
        selectedToken.decimal,
        disputeType
      );

      taskId = res?.events?.TaskCreated?.returnValues?.taskId;
      taskTransactionHash = res?.transactionHash;

      setLoader(false);
    } catch (error) {
      toast?.error("Error during task creation");
      handleContractError(error);
      setLoader(false);
      return;
    }

    // ✅ This now works since disputeType is always defined above
    await saveTaskData(taskId, taskTransactionHash, disputeType);
  };

  const handleApprovalAndCreateTask = async () => {
    const approvalSuccess = await handleApproval();
    if (approvalSuccess) {
      await handleCreateTask();
    }
  };



  console.log(selectedToken.currencyAddress, 'balance');

  // Helper function to get the balance
  const getBalance = async (selectedToken) => {
    let balance;
    if (selectedToken?.decimal === 18 && selectedToken?.type === "coin") {
      balance = await web3.eth.getBalance(account);
      return web3.utils.fromWei(balance);
    } else if (selectedToken?.decimal === 18) {
      balance = await BalanceOfHook(selectedToken.currencyAddress);
      return web3.utils.fromWei(balance);
    } else if (selectedToken?.decimal === 6) {
      balance = await BalanceOfHook(selectedToken.currencyAddress);
      return web3.utils.fromWei(balance.toString(), "mwei");
    } else if (selectedToken?.decimal === 8) {
      balance = await BalanceOfHook(selectedToken.currencyAddress);
      return (
        parseFloat(balance) / Math.pow(10, parseInt(selectedToken?.decimal))
      );
    }
    return 0;
  };

  // Helper function to handle contract-related errors
  const handleContractError = (error) => {
    console.log(error, "AllowanceCore handleContractError");

    if (error.message?.includes("insufficient funds")) {
      toast.error(
        "Insufficient funds. Please ensure your balance is sufficient to create this task."
      );
    } else if (error.message?.includes("revert")) {
      toast.error(
        "Transaction reverted. Please check your input or contract settings."
      );
    } else {
      toast.error(
        // "Failed to create task on the blockchain. Please check allowance or try again.",
        error?.message
      );
      // CustomToast.show('error', 'Error!', 'Failed to create task on the blockchain. Please check allowance or try again.')
    }
    console.error("Allowance or contract call failed:", error);
  };

  // Helper function to save task data through API
  const saveTaskData = async (taskId, taskTransactionHash, disputeType) => {
    const accessToken = localStorage.getItem("accessToken");
    const taskData = {
      title,
      description: value,
      requirements: taskRequirements,
      additionalRequest: additionalRequest,
      deliveryFormat: deliveryFormat,
      timeZone: selectedTimezone,
      taskTransactionHash,
      reward: parseFloat(reward),
      categoryId: selectedCategory?.id,
      contractTaskId: taskId,
      disputeType: disputeType === 0 ? 'mini' : 'regular',
      currency: selectedToken.currency,
      currencySymbol: selectedToken.currencySymbol,
      currencyAddress: selectedToken.currencyAddress,
      endTime: new Date(endDate).toISOString(),
      serviceType: serviceType.toLowerCase(),
      ...(serviceType === "Physical" &&
        selectedCountry &&
        selectedCity && {
        locations: {
          [selectedCountry]: [selectedCity],
        },
      }),
    };

    // Filter taskData object
    const filteredTaskData = Object.fromEntries(
      Object.entries(taskData).filter(([_, value]) => isNonEmpty(value))
    );

    try {
      setLoader(true);
      const response = await fetch(`${API_URL}tasks`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(filteredTaskData),
      });

      if (response.ok) {
        const result = await response.json();
        // console.log('Task created successfully:', result);
        setTaskCreated(result?.data);
        // clearForm();
        handleShow();
      } else {
        console.error("Failed to create task:", response.statusText);
        toast.error("Failed to create task in the system.");
      }
    } catch (error) {
      console.error("Error occurred while creating task:", error);
      toast.error("An error occurred while creating the task.");
    } finally {
      setLoader(false);
    }
  };

  const editTaskData = async () => {
    const accessToken = localStorage.getItem("accessToken");
    const taskData = {
      requirements: taskRequirements,
      additionalRequest: additionalRequest,
      deliveryFormat: deliveryFormat,
      timeZone: selectedTimezone,
      categoryId: selectedCategory?.id,
      endTime: new Date(endDate).toISOString(),
      serviceType: serviceType.toLowerCase(),
      ...((serviceType === "Physical" || serviceType === "physical") &&
        selectedCountry &&
        selectedCity && {
        locations: {
          [selectedCountry]: [selectedCity],
        },
      }),
    };

    // Filter taskData object
    const filteredTaskData = Object.fromEntries(
      Object.entries(taskData).filter(([_, value]) => isNonEmpty(value))
    );

    try {
      setLoader(true);
      const response = await fetch(`${API_URL}tasks/${editId}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(filteredTaskData),
      });

      if (response.ok) {
        const result = await response.json();
        // console.log('Task created successfully:', result);
        handleShow();
        clearForm();
        // navigate(`/similartaskdetail/${editId}`)
      } else {
        console.error("Failed to create task:", response.statusText);
        toast.error("Failed to create task in the system.");
      }
    } catch (error) {
      console.error("Error occurred while creating task:", error);
      toast.error("An error occurred while creating the task.");
    } finally {
      setLoader(false);
    }
  };
  // Helper function to clear the form
  // console.log(selectedOptions, deliveryFormat, 'dfasfasfasfasdf');

  const clearForm = () => {
    setTitle("");
    setValue("");
    setReward("");
    setEndDate("");
    setContact("");
    setTaskRequirements("");
    setAdditionalRequest("");
    setSelectedTimezone("Select time zone");
    setDeliveryFormat([]);
    setSelectedCategory("");
    setSelectedToken({});
    setErrors({});
    setSelectedOptions([]);
    setSelectedCountry();
    setSelectedCity();
  };

  const fetchTasksCategories = async () => {
    try {
      const response = await fetch(`${API_URL}tasks-categories?limit=${50}`, {
        method: "GET", // HTTP method
        headers: {
          "Content-Type": "application/json", // Set the content type if needed
          // No authorization header needed since you're not using an access token
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setCategories(data?.data?.taskCategories);
      // // console.log(data?.data, 'datasdDS'); // Handle your data here
    } catch (error) {
      console.error("Error fetching tasks categories:", error);
    }
  };
  // Define validation conditions
  const isValid =
    title &&
    value &&
    reward &&
    selectedCategory &&
    selectedToken.currencySymbol &&
    endDate &&
    selectedTimezone !== "Select time zone";

  const handlePreviewClick = () => {
    if (isValid) {
      const taskData = {
        title,
        description: value,
        requirements: taskRequirements,
        additionalRequest: additionalRequest,
        deliveryFormat: deliveryFormat,
        timeZone: selectedTimezone,
        // taskTransactionHash,
        reward: parseFloat(reward),
        categoryId: selectedCategory?.id,
        // contractTaskId: taskId,
        currency: selectedToken.currency,
        currencySymbol: selectedToken.currencySymbol,
        currencyAddress: selectedToken.currencyAddress,
        endTime: new Date(endDate).toISOString(),
        serviceType: serviceType.toLowerCase(),
        ...(serviceType === "Physical" &&
          selectedCountry &&
          selectedCity && {
          locations: {
            [selectedCountry]: [selectedCity],
          },
        }),
        selectedCountry,
        selectedCity,
        editId
      };

      // Filter taskData object
      const filteredTaskData = Object.fromEntries(
        Object.entries(taskData).filter(([_, value]) => isNonEmpty(value))
      );

      // Navigate to /taskperview with filteredTaskData in state
      // let data = JSON.stringify(filteredTaskData)
      // navigate(`/taskperview?${data}`);
      navigate("/taskperview", { state: { filteredTaskData } });
    } else {
      console.warn(
        "Please fill out all required fields before previewing the task."
      );
    }
  };

  const fetchTaskData = async (id) => {
    try {
      setLoader(true);
      const accessToken = localStorage.getItem("accessToken");
      const config = accessToken
        ? { headers: { Authorization: `Bearer ${accessToken}` } }
        : {}; // If no token, leave headers empty
      const response = await axios.get(`${API_URL}tasks/${id}`, config);
      let taskData = response?.data?.data;

      // Update states based on the taskData object
      setTitle(taskData.title);
      setReward(taskData.reward);
      setValue(taskData.description || "");
      setTaskRequirements(taskData.requirements || "");
      setAdditionalRequest(taskData.additionalRequest || "");
      setDeliveryFormat(taskData.deliveryFormat || []);
      setSelectedTimezone(taskData.timeZone || "Select time zone");
      setServiceType(taskData.serviceType || "Digital");
      {
        taskData?.locations &&
          Object.entries(taskData.locations).map(
            ([country, cities]) => (

              setSelectedCountry(country || null),
              setSelectedCity(cities?.[0] || null)
            )
          )
      }
      setContact(taskData.contactInfo || "");
      // Convert `taskData.endTime` to a format compatible with `datetime-local` input
      const formattedEndDate = taskData.endTime
        ? new Date(taskData.endTime).toLocaleString("sv-SE").replace(" ", "T")
        : "";
      setEndDate(formattedEndDate);
      setSelectedCategory(taskData.tasksCategory || "");
      const token = tokens.find(
        t =>
          t.currency === taskData.currency ||
          t.currencySymbol === taskData.currencySymbol ||
          t.currencyAddress === taskData.currencyAddress
      );

      if (token) {
        setSelectedToken({
          currency: token.currency,
          currencySymbol: token.currencySymbol,
          currencyAddress: token.currencyAddress,
          decimal: token.decimal,
          imgSrc: token.imgSrc,
          type: token.type || "unknown", // Default to "unknown" if type is not defined
        });
      } else {
        // Handle the case where no matching token is found
        setSelectedToken({
          currency: taskData.currency,
          currencySymbol: taskData.currencySymbol,
          currencyAddress: taskData.currencyAddress,
          decimal: null,
          imgSrc: null,
          type: "unknown",
        });
      }

      const selectedFormatIds = deliveryFormats
        .filter(option => taskData.deliveryFormat.includes(option.label))
        .map(option => option.value);

      setSelectedOptions(selectedFormatIds);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error("Error fetching task data:", error);
      // Add error handling logic as needed
    }
  };
  // console.log(selectedToken, 'deliveryFormat');
  // console.log(selectedOptions,);

  useEffect(() => {
    if (editId) {
      fetchTaskData(editId)
    }
  }, [editId])

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchTasksCategories();
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  // useEffect(() => {
  //   const checkAndSetAllowance = async () => {
  //     if (!account || !selectedToken || !reward) return;

  //     const platformFee = parseFloat(reward) * (selectedToken.currencySymbol === 'TASK' ? 0.03 : 0.05);
  //     const TOTAL_REQUIRED_REWARD_AMOUNT = parseFloat(reward) + platformFee;

  //     try {
  //       const currentAllowance = await checkAllowanceOnly(
  //         Environment.tastManager,
  //         selectedToken.currencyAddress,
  //         TOTAL_REQUIRED_REWARD_AMOUNT,
  //         selectedToken.decimal
  //       );

  //       setHasAllowance(parseFloat(currentAllowance) >= TOTAL_REQUIRED_REWARD_AMOUNT);
  //     } catch (error) {
  //       console.error("Error checking allowance:", error);
  //       setHasAllowance(false);
  //     }
  //   };

  //   checkAndSetAllowance();
  // }, [account, selectedToken, reward]);


  useEffect(() => {
    // Check if the navigation state indicates task creation
    setTimeout(() => {
      if (location.state?.createTask && account) {
        // setLoader(true);
        if (editId) {
          handleEdit()
        } else {
          handleShow1();

          // if (window.innerWidth <= 991) {
          //   handleShow1();
          // } 
          // handleSubmit();
        }
      }
    }, 300);
  }, [location.state]);


  //  ================================= Social Share ========================================== //

  const [copied, setCopied] = useState(false);
  const [url, setUrl] = useState(''); // URL state

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setUrl(window.location.href); // Safely set the URL
    }
  }, []);

  const handleCopyURL = async (e, customURL) => {
    e.preventDefault();

    copy(customURL, {
      debug: true,
      message: 'Press Ctrl+C to copy the URL',
    });

    setCopied(true);
    setTimeout(() => setCopied(false), 2000); // Reset copied state after 2 seconds
  };


  const twitterPost = () => {
    // const taskTitle = taskCreated?.title || "An Exciting Task";
    const tweetUrl = `${Environment?.siteURL}/similartaskdetail/${taskCreated?.id}`;
    const tweetText = `✅ I just created a new task! Come check it out and join to earn rewards if you’re interested! Check it out here:`
    const twitterShareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(tweetText)}&url=${encodeURIComponent(tweetUrl)}`;

    window.open(twitterShareUrl, "_blank");
    console.log(twitterShareUrl, "social");
  };

  const telegramPost = (e) => {
    e.preventDefault()
    // const taskTitle = taskCreated?.title || "An Exciting Task";
    const taskUrl = `${Environment?.siteURL}/similartaskdetail/${taskCreated?.id}`;
    const message = `✅ I just created a new task! Come check it out and join to earn rewards if you’re interested! Check it out here: ${taskUrl}`;

    const telegramUrl = `https://t.me/share/url?url=${encodeURIComponent(taskUrl)}&text=${encodeURIComponent(message)}`;

    window.open(telegramUrl, "_blank");
    console.log(telegramUrl, "social");
  };

  const facebookPost = () => {
    const taskUrl = `${Environment?.siteURL}/similartaskdetail/${taskCreated?.id}`;
    const message = `✅ I just created a new task! Come check it out and join to earn rewards if you’re interested! Check it out here: ${taskUrl}`;
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(taskUrl)}&text=${encodeURIComponent(message)}`;

    window.open(facebookUrl, "_blank");
    console.log(facebookUrl, "social");
  };

  // const facebookPost = () => {
  //   // Use HTTPS + a domain (IPs are blocked)
  //   const taskUrl = `https://lp.tasks.market/similartaskdetail/${taskCreated?.id}`;
  //   const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(taskUrl)}`;

  //   window.open(facebookUrl, "_blank");
  // };

  const emailPost = () => {
    const taskUrl = `${Environment?.siteURL}/similartaskdetail/${taskCreated?.id}`;

    const emailSubject = encodeURIComponent(taskCreated?.title);
    const emailBody = encodeURIComponent(
      `✅ I just created a new task! 🚀\n\n` +
      `Come check it out and join to earn rewards if you're interested!\n\n` +
      `Check it out here: ${taskUrl}`
    );

    const emailUrl = `mailto:?subject=${emailSubject}&body=${emailBody}`;

    window.open(emailUrl, "_blank");
    console.log(emailUrl, "social");
  };



  //  ================================= Social Share ========================================== //

  const renderTooltipDuration = (props) => (
    <Tooltip id="button-tooltip " className="tolltipssss" {...props}>
      If no submissions are received within this period, you can extend the task duration by an additional 30 days at no extra cost.
    </Tooltip>
  );

  return (
    <>
      {/* {loader && <Loader text={<button className='loderbtn' onClick={() => setLoader(false)}>close</button>} />} */}
      {loader && <Loader />}
      <section className="create_task">
        <img src="\assets\createtask\backkgroundimg.png" className="backimg" />
        <div className="custom-container">
          {/* <Navbar /> */}
          <div className="outter_main">
            <h1 className="mb-3">Create Task</h1>
            {/* <p className="loremmmm">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</p> */}
            <p className="parahead">
              Provide details about the task you want to create. Make sure to
              fill in all required fields to help potential participants
              understand the task requirements.
            </p>
            <h6 className="bottom">
              Field marked <span>*</span> are required
            </h6>
            <div className="inner_main">
              <TitleInput
                title={title}
                handleInputChange={handleInputChange}
                error={errors.title}
                editId={editId}
              />
              {errors.title && <p className="error-text">{errors.title}</p>}{" "}
              {/* Error message */}
              <h6>
                Task Details<span>*</span>
              </h6>
              <div className="text-editor-container myyyeditor">
                <TextEditor
                  description={
                    "Describe the task in detail. Include the purpose, any specific goals, and background information that participants should know."
                  }
                  value={value}
                  setValue={(val) => handleInputChange("description", val)}
                  editId={editId}
                />
              </div>
              {errors.description && (
                <p className="error-text">{errors.description}</p>
              )}{" "}
              {/* Error message */}
              <h6>Task Requirements</h6>
              <div className="text-editor-container myyyeditor">
                <TextEditor
                  description="List any specific requirements for completing the task, such as skills, tools, or qualifications needed."
                  value={taskRequirements}
                  setValue={(val) => handleInputChange("taskRequirements", val)}
                />
              </div>
              <h6>
                Delivery Format <span>*</span>
              </h6>
              <CustomSelect
                setDeliveryFormat={setDeliveryFormat}
                placeholder="Select delivery format"
                setSelectedOptions={setSelectedOptions}
                selectedOptions={selectedOptions}
                handleInputChange={handleInputChange}
              />
              {errors.deliveryFormat && (
                <p className="error-text2">{errors.deliveryFormat}</p>
              )}{" "}
              {/* Error message */}
              <h6 className="forpad">Additional Requests</h6>
              <div className="text-editor-container myyyeditor">
                <TextEditor
                  description="Add any extra instructions or requests that may help participants better understand your expectations for this task."
                  value={additionalRequest}
                  setValue={(val) =>
                    handleInputChange("additionalRequest", val)
                  }
                />{" "}
              </div>
              <h6 className="forpad">
                Category <span>*</span>
              </h6>
              <Dropdown className="categories-dropdownlist">
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  {selectedCategory?.categoryName || "Select task category..."}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M13.3333 8.33337L9.99996 11.6667L6.66663 8.33337"
                      stroke="#013159"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {categories?.map((category, index) => (
                    <Dropdown.Item
                      key={index}
                      onClick={() => handleCategorySelect(category)}
                    >
                      {category?.categoryName}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
              {errors.category && (
                <p className="error-text">{errors.category}</p>
              )}{" "}
              {/* Error message */}
              <ServiceType
                setServiceType={setServiceType}
                serviceType={serviceType}
                selectedCountry={selectedCountry}
                setSelectedCountry={setSelectedCountry}
                selectedCity={selectedCity}
                setSelectedCity={setSelectedCity}
              />
              <div className="innner_center">
                <div className="secondrop">
                  <h6>
                    Reward Currency <span>*</span>
                  </h6>
                  <Dropdown className={editId ? 'disabledClass' : null}>
                    <Dropdown.Toggle
                      disabled={editId} variant="success" id="dropdown-basic">
                      {selectedToken.currencySymbol || "Select reward currency"}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M13.3333 8.33337L9.99996 11.6667L6.66663 8.33337"
                          stroke="#013159"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {tokens.map((token, index) => (
                        <Dropdown.Item
                          key={index}
                          onClick={() => handleTokenSelect(token)}
                        >
                          <div className="mainparenttoken">
                            <div className="left">
                              <img
                                src={token.imgSrc}
                                alt={token.currency}
                                style={{ marginRight: "8px", width: '20px' }}
                              />
                              {token.currencySymbol}
                            </div>

                            <button className={token.currencySymbol === 'TASK' ? ' greennewtoken m-0' : "invisible d-none m-0"}>40% OFF</button>
                          </div>
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                  {errors.currency && (
                    <p className="error-text">{errors.currency}</p>
                  )}{" "}
                  {/* Error message */}
                </div>
                <div className="thrddrop">
                  <h6>
                    Reward Amount <span>*</span>
                  </h6>
                  <input
                    type="text"
                    inputMode="decimal"
                    // pattern="^\d*\.?\d*$"
                    placeholder="Enter task reward..."
                    value={reward}
                    disabled={editId}
                    onChange={(e) =>
                      handleInputChange("reward", e.target.value)
                    }
                    className={editId ? 'disabledClass' : null}
                  />
                  {errors.reward && (
                    <p className="error-text">{errors.reward}</p>
                  )}{" "}
                  {/* Error message */}
                </div>
              </div>
              {/* <div className="thrddrop">
                                <h6>My Contact <span>*</span></h6>
                                    <input
                                        type="text"
                                        placeholder='Enter Contact Info...'
                                        value={contact}
                                        onChange={(e) => setContact( e.target.value)}
                                    />
                                    
                                </div>
                            {errors.endDate && <p className="error-text">{errors.endDate}</p>} Error message */}
              <div className="mainparentsssss">
                <div className="second">
                  <div className="drop">
                    <TimezoneDropdown
                      setSelectedTimezone={setSelectedTimezone}
                      selectedTimezone={selectedTimezone}
                      handleInputChange={handleInputChange}
                    />
                    {errors.selectedTimezone && (
                      <p className="error-text hhhhhhhhhh">
                        {errors.selectedTimezone}
                      </p>
                    )}
                  </div>
                </div>

                <div className="second">
                  <h6>
                    Task End Date <span>*</span>
                  </h6>
                  <div className="typedate-field">
                    <label
                      htmlFor="endDate"
                      className={
                        endDate ? "d-none" : "showinputtypedate-text d-none"
                      }
                      style={{
                        position: "absolute",
                        top: endDate ? "" : "20px",
                        left: "15px",
                        fontSize: endDate ? "12px" : "16px",
                        color: "#627F97",
                        pointerEvents: "none",
                        transition: "0.2s ease",
                      }}
                    >
                      DD/HH/MM/SS
                    </label>
                    <input
                      type="datetime-local"
                      value={endDate}
                      onChange={(e) =>
                        handleInputChange("endDate", e.target.value)
                      }
                      min={new Date().toISOString().slice(0, -8)} // Set minimum date-time to current
                    />
                    <img
                      src="\assets\calendar-icon.svg"
                      alt="img"
                      className="img-fluid"
                    />
                  </div>
                  {errors.endDate && (
                    <p className="error-text">{errors.endDate}</p>
                  )}{" "}
                  {/* Error message */}
                </div>
              </div>
            </div>
            <h6 className="task-duration">Task duration cannot exceed <span>30 Days</span>  <OverlayTrigger
              placement="bottom"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltipDuration}
            >
              <svg style={{ cursor: "pointer" }} xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M6 1.125C5.03582 1.125 4.09329 1.41091 3.2916 1.94659C2.48991 2.48226 1.86507 3.24363 1.49609 4.13442C1.12711 5.02521 1.03057 6.00541 1.21867 6.95107C1.40678 7.89672 1.87108 8.76537 2.55286 9.44715C3.23464 10.1289 4.10328 10.5932 5.04894 10.7813C5.99459 10.9694 6.97479 10.8729 7.86558 10.5039C8.75637 10.1349 9.51775 9.51009 10.0534 8.70841C10.5891 7.90672 10.875 6.96418 10.875 6C10.8736 4.70749 10.3596 3.46831 9.44564 2.55436C8.5317 1.64042 7.29251 1.12636 6 1.125ZM5.8125 3.375C5.92375 3.375 6.03251 3.40799 6.12501 3.4698C6.21751 3.53161 6.28961 3.61946 6.33218 3.72224C6.37476 3.82502 6.3859 3.93812 6.36419 4.04724C6.34249 4.15635 6.28892 4.25658 6.21025 4.33525C6.13158 4.41391 6.03136 4.46749 5.92224 4.48919C5.81313 4.5109 5.70003 4.49976 5.59724 4.45718C5.49446 4.41461 5.40661 4.34251 5.3448 4.25001C5.28299 4.15751 5.25 4.04875 5.25 3.9375C5.25 3.78832 5.30927 3.64524 5.41475 3.53975C5.52024 3.43426 5.66332 3.375 5.8125 3.375ZM6.375 8.625C6.17609 8.625 5.98532 8.54598 5.84467 8.40533C5.70402 8.26468 5.625 8.07391 5.625 7.875V6C5.52555 6 5.43016 5.96049 5.35984 5.89017C5.28951 5.81984 5.25 5.72446 5.25 5.625C5.25 5.52554 5.28951 5.43016 5.35984 5.35984C5.43016 5.28951 5.52555 5.25 5.625 5.25C5.82392 5.25 6.01468 5.32902 6.15533 5.46967C6.29598 5.61032 6.375 5.80109 6.375 6V7.875C6.47446 7.875 6.56984 7.91451 6.64017 7.98484C6.71049 8.05516 6.75 8.15054 6.75 8.25C6.75 8.34946 6.71049 8.44484 6.64017 8.51517C6.56984 8.58549 6.47446 8.625 6.375 8.625Z" fill="#B4C2CD" />
              </svg>
            </OverlayTrigger> </h6>
            <div className="lightgreencard">
              <button className="upperbutton">
                <img width={18} height={18} src="/assets/createtask/Tasktoken.png" alt="img" className="img-fluid" /> Special Promo - 40% OFF
              </button>
              <p>Save on fees! Pay with $TASK tokens and enjoy a 40% discount on platform fees - just 3% instead of 5%</p>
            </div>
            <div className="d-flex w-100">
              <button
                onClick={handlePreviewClick}
                className={
                  isValid ? "previewone w-50 mx-1" : "preview w-50 mx-1"
                }
                disabled={!isValid} // Optionally disable button if not valid
              >
                Preview Task
              </button>
              {/* <button className="btn-createtask w-50 mx-1" onClick={clearForm}>Clear Form</button> */}
              {editId ? <button
                className="btn-createtask w-50 mx-1"
                onClick={handleEdit}
              >
                Save Changes
              </button> :
                <>
                  <button
                    className="btn-createtask w-50 mx-1"
                    onClick={() => handleApprovalAndCreateTask()}
                  >
                    Create Task
                  </button>
                  {/* {window.innerWidth <= 991 ? (
                    hasAllowance ? (
                      <button
                        className="btn-createtask w-50 mx-1"
                        onClick={handleCreateTask}
                      >
                        Create Task
                      </button>
                    ) : (
                      <button
                        className="btn-createtask w-50 mx-1"
                        onClick={handleApproval}
                      >
                        Approve
                      </button>
                    )
                  ) : (
                    hasAllowance ? (
                      <button
                        className="btn-createtask w-50 mx-1"
                        onClick={handleCreateTask}
                      >
                        Create Task
                      </button>
                    ) : (
                      <button
                        className="btn-createtask w-50 mx-1"
                        onClick={handleApproval}
                      >
                        Approve
                      </button>
                    )
                  )} */}
                </>
              }
            </div>
            {editId ? null : <div className="text-center text-secondary text-decoration-underline mt-3">
              <small className="cp" onClick={clearForm}>
                Clear Form
              </small>
            </div>}
          </div>
        </div>
      </section>

      <Modal show={show} onHide={handleClose} className="modal_main2 modal_main createtask-modal" centered>
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="modal4">
            <img className="imgqus" src="\assets\createtask\tick.png" />
            <h1>Task Successfully {editId ? 'Edited' : 'Created'} </h1>
            <p>All set! Your task is live! <br />
              Spread the word and get more participants on board.</p>
          </div>
          <div className="social-area">
            <h6>Share on</h6>
            <div className="social-icons">
              <div className="single-icon" onClick={() => twitterPost()}>
                <a href="https://x.com/" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                  <path d="M15.62 1.875H18.3767L12.3542 8.75833L19.4392 18.125H13.8917L9.54667 12.4442L4.575 18.125H1.81667L8.25834 10.7625L1.46167 1.875H7.15L11.0775 7.0675L15.62 1.875ZM14.6525 16.475H16.18L6.32 3.43833H4.68084L14.6525 16.475Z" fill="#013159" />
                </svg></a>
                <p>X</p>
              </div>
              <div className="single-icon" onClick={() => facebookPost()}>
                <a href="https://www.facebook.com/" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                  <path d="M12.4654 20V10.8777H15.5262L15.9854 7.32156H12.4654V5.05147C12.4654 4.0222 12.7501 3.32076 14.2277 3.32076L16.1093 3.31999V0.13923C15.7839 0.0969453 14.667 0 13.367 0C10.6524 0 8.7939 1.65697 8.7939 4.69927V7.32156H5.72388V10.8777H8.7939V20H12.4654Z" fill="#013159" />
                </svg></a>
                <p>Facebook</p>
              </div>
              <div className="single-icon" >
                <a href="https://t.me/" onClick={(e) => telegramPost(e)}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                    <path d="M15.8843 9.02378C16.4721 8.41847 17.0557 7.00606 14.6064 8.72112C12.3184 10.3427 10.0149 11.9408 7.69624 13.5154C7.34316 13.6798 6.96144 13.7691 6.57403 13.7777C6.18663 13.7864 5.80152 13.7143 5.44184 13.5659C3.97227 13.1119 2.25671 12.5066 2.25671 12.5066C2.25671 12.5066 1.08532 11.7488 3.09053 10.9417C3.09053 10.9417 11.5682 7.35916 14.5084 6.09699C15.6351 5.59256 19.457 3.97839 19.457 3.97839C19.457 3.97839 21.2215 3.27109 21.0746 4.98725C21.0256 5.69345 20.6337 8.16735 20.2418 10.8408C19.653 14.6252 19.0161 18.7637 19.0161 18.7637C19.0161 18.7637 18.9182 19.9239 18.0854 20.1257C17.194 20.1101 16.3327 19.7908 15.6361 19.2177C15.4402 19.0663 11.9612 16.7953 10.6865 15.6856C10.5568 15.5951 10.4514 15.4724 10.3802 15.3287C10.3091 15.1851 10.2742 15.0252 10.2791 14.864C10.284 14.7028 10.3285 14.5456 10.4082 14.4067C10.488 14.268 10.6005 14.1522 10.7355 14.0703C12.4838 12.4231 14.2003 10.7406 15.8843 9.02378Z" fill="#013159" />
                  </svg>
                </a>
                <p>Telegram</p>
              </div>
              <div className="single-icon" onClick={() => emailPost()}>
                <a href="mailto:your@email.com"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <g clip-path="url(#clip0_4684_9370)">
                    <path d="M11.6714 12.2536C11.1739 12.5853 10.5959 12.7606 10 12.7606C9.40414 12.7606 8.82617 12.5853 8.32859 12.2536L0.133164 6.78977C0.0876953 6.75945 0.0433984 6.72785 0 6.69535V15.6484C0 16.6748 0.833008 17.4895 1.84113 17.4895H18.1588C19.1853 17.4895 20 16.6565 20 15.6484V6.69531C19.9565 6.72789 19.9121 6.75957 19.8665 6.78992L11.6714 12.2536Z" fill="#013159" />
                    <path d="M0.783203 5.81414L8.97863 11.278C9.28887 11.4848 9.64441 11.5882 9.99996 11.5882C10.3555 11.5882 10.7111 11.4848 11.0214 11.278L19.2168 5.81414C19.7072 5.48738 20 4.94051 20 4.35027C20 3.33539 19.1743 2.50977 18.1595 2.50977H1.84051C0.825664 2.5098 0 3.33543 0 4.35125C0 4.94051 0.292812 5.48738 0.783203 5.81414Z" fill="#013159" />
                  </g>
                  <defs>
                    <clipPath id="clip0_4684_9370">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg></a>
                <p>Email</p>
              </div>
              <div className="single-icon">
                <a href="#" onClick={(e) => handleCopyURL(e, `${Environment?.siteURL}/similartaskdetail/${taskCreated?.id}`)}><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <g clip-path="url(#clip0_4684_9376)">
                    <path d="M12.2029 7.79613C11.966 7.55781 11.7033 7.34656 11.4198 7.16624C10.6687 6.68527 9.79545 6.4297 8.90354 6.4297C7.6656 6.42739 6.47796 6.91926 5.60413 7.79613L1.36489 12.0387C0.49255 12.9127 0.00224692 14.0969 0.00146581 15.3318C-0.000174521 17.9087 2.08742 19.9989 4.6643 20.0006C5.90033 20.0049 7.08687 19.5154 7.96039 18.6408L11.4598 15.1415C11.5233 15.0784 11.5588 14.9924 11.5583 14.9029C11.5573 14.7188 11.4072 14.5705 11.2231 14.5716H11.0898C10.3587 14.5741 9.63411 14.4337 8.95689 14.1583C8.83211 14.107 8.68869 14.1359 8.59363 14.2316L6.07741 16.7512C5.29606 17.5325 4.02926 17.5325 3.24791 16.7512C2.46657 15.9698 2.46657 14.703 3.24791 13.9217L7.50383 9.66911C8.28455 8.88937 9.54928 8.88937 10.33 9.66911C10.8562 10.1643 11.6769 10.1643 12.203 9.66911C12.4294 9.44255 12.5666 9.14206 12.5896 8.82259C12.6139 8.44082 12.4731 8.06694 12.2029 7.79613Z" fill="#013159" />
                    <path d="M18.6319 1.36666C16.8097 -0.455553 13.8553 -0.455553 12.0331 1.36666L8.53703 4.85935C8.44103 4.95582 8.41334 5.10091 8.46704 5.22597C8.52012 5.35137 8.64416 5.43187 8.78031 5.42925H8.9036C9.63386 5.42792 10.3573 5.56942 11.0332 5.84585C11.158 5.89721 11.3014 5.86823 11.3965 5.77255L13.906 3.26632C14.6874 2.48497 15.9542 2.48497 16.7355 3.26632C17.5169 4.04766 17.5169 5.31447 16.7355 6.09581L13.6094 9.21857L13.5827 9.24856L12.4896 10.335C11.7089 11.1148 10.4441 11.1148 9.66343 10.335C9.13727 9.83986 8.31656 9.83986 7.79044 10.335C7.56263 10.5633 7.42528 10.8664 7.40383 11.1882C7.37946 11.57 7.52026 11.9439 7.79044 12.2147C8.1762 12.6021 8.62752 12.918 9.12353 13.1479C9.19351 13.1812 9.2635 13.2079 9.33349 13.2378C9.40348 13.2678 9.47678 13.2912 9.54677 13.3178C9.61676 13.3445 9.69006 13.3678 9.76005 13.3878L9.9567 13.4411C10.09 13.4744 10.2233 13.5011 10.3599 13.5244C10.5245 13.5489 10.6903 13.5645 10.8565 13.5711H11.0898H11.1098L11.3098 13.5478C11.3831 13.5445 11.4597 13.5278 11.5464 13.5278H11.6597L11.8897 13.4945L11.9963 13.4745L12.1896 13.4345H12.2263C13.0449 13.2289 13.7925 12.805 14.3892 12.208L18.6318 7.96547C20.4541 6.14326 20.4541 3.18887 18.6319 1.36666Z" fill="#013159" />
                  </g>
                  <defs>
                    <clipPath id="clip0_4684_9376">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg></a>
                {
                  copied ? <p>Copied!</p> :
                    <p>Copy Link</p>
                }
              </div>

            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="modal_footer">
            <Link to={editId ? `/similartaskdetail/${editId}` : "/latesttask"} className="surebutton text-center">
              OK
            </Link>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal show={show1} onHide={handleClose1} className="modal_main2" centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirmation!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="modal4">
            <img className="imgqus" src="\assets\createtask\tick.png" />
            <p>Are you sure you want to proceed with this task!</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="modal_footer twice-btns">
            <button className="btn-explore" onClick={handleClose1}>
              Cancel
            </button>
            {/* <button className="btn-create" >
              Create Task
            </button> */}

            <>
              {window.innerWidth <= 991 ? (
                hasAllowance ? (
                  <button
                    className="btn-create w-50 mx-1"
                    onClick={handleCreateTask}
                  >
                    Create Task
                  </button>
                ) : (
                  <button
                    className="btn-create w-50 mx-1"
                    onClick={handleApproval}
                  >
                    Approve
                  </button>
                )
              ) : (
                hasAllowance ? (
                  <button
                    className="btn-create w-50 mx-1"
                    onClick={handleCreateTask}
                  >
                    Create Task
                  </button>
                ) : (
                  <button
                    className="btn-create w-50 mx-1"
                    onClick={handleApproval}
                  >
                    Approve
                  </button>
                )
              )}
            </>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Createtask;